const ASSET_PATH = {
  IMAGE: '/static/images',
  ICON: '/static/icons',
}

export function getImagePath(filename: string, directory = '') {
  return ASSET_PATH.IMAGE + (directory ? '/' + directory : '') + '/' + filename
}

export function getIconPath(filename: string, directory = '') {
  return ASSET_PATH.ICON + (directory ? '/' + directory : '') + '/' + filename
}
